<script setup lang="ts">
import type { EasyfunGameJson } from '~/types/easyfun'

interface Props {
  list: EasyfunGameJson[] | undefined
}

defineProps<Props>()

const { toAppDetail } = useRouterToPage()
</script>

<template>
  <div>
    <div v-show="list?.length" class="mx-auto w-fit flex" mb="28px md:60px">
      <Icon class="v-sub text-26px c-yellow-5 lt-md:hidden" name="Lightning" />
      <h2 class="select-none c-#ffffffe5 font-800" mx="20px md:14px" text="center 18px md:32px" lh="28px md:32px">
        {{ $t('home_page.easyfun_title') }}
      </h2>
      <Icon class="v-sub text-26px c-yellow-5 lt-md:hidden" name="Lightning" />
    </div>

    <div
      v-if="list?.length"
      class="relative z-2" grid="~ rows-2"
      lt-md="grid-cols-4 gap-[20px_12px] py-20px px-12px"
      md="grid-cols-6 gap-[24px_40px] p-40px pb-24px"
      lg="grid-cols-8"
      b="~ solid transparent rd-8px" bg="clip-[padding-box,border-box] origin-[padding-box,border-box] image-[linear-gradient(#1D1B31,#1D1B31),linear-gradient(145deg,#fff3,transparent_50%)]"
    >
      <template v-for="item in list" :key="item.gameId">
        <GameLiteBlock
          v-track="{ id: 'web-index-recommend-game', click: { value: { type: 'online', name: item.mnqInfo.gameName, seo: item.seo, pkg: item.packageName } } }" mode="dark"
          :name="item.mnqInfo.gameName"
          :icon="item.icon"
          :to="toAppDetail({ seo: item.mnqInfo.seo![$i18n.locale], type: item.mnqInfo.typeName }, { hasReturnUrl: true })"
          name-class="lt-md:font-400 lt-md:text-12px"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
